import { createTheme } from '@mantine/core';

import { customMantineColors, semanticColors } from './theme.colors';
import { componentsConfig } from './theme.components';
import { breakpoints, spacing, radius, shadows } from './theme.variables';
import {
  fontFamilyBase,
  fontFamilyHeading,
  fontFamilyDisplay,
  fontSize,
  fontWeight,
  lineHeights,
} from './theme.typography';

export const theme = createTheme({
  // Global Overrides
  breakpoints,
  spacing,
  defaultRadius: 'sm',
  radius,
  shadows,
  // Component Overrides
  components: componentsConfig,
  // Typography Overrides
  fontFamily: fontFamilyBase,
  fontSizes: fontSize,
  headings: {
    fontWeight: fontWeight.book,
    fontFamily: fontFamilyHeading,
    // Line spacing set in Title component config
    sizes: {
      h1: { fontSize: fontSize.xl5, lineHeight: lineHeights.xl4 },
      h2: { fontSize: fontSize.xl4, lineHeight: lineHeights.xl3 },
      h3: { fontSize: fontSize.xl3, lineHeight: lineHeights.xl2 },
      h4: { fontSize: fontSize.xl2, lineHeight: lineHeights.xl },
      h5: { fontSize: fontSize.xl, lineHeight: lineHeights.lg },
      h6: { fontSize: fontSize.lg, lineHeight: lineHeights.md },
    },
  },
  fontFamilyMonospace: fontFamilyDisplay,
  lineHeights,
  // Color overrides
  colors: customMantineColors,
  primaryColor: 'neutral',
  primaryShade: 8,
  white: '#fff',
  black: semanticColors.content.primary,
});
